import { EffectStyles } from "./styles";
import imgEffect from "assets/img/effect.png";

export default function Effect() {
  const effect = {
    vwStart: Math.random() * -5,
    vhStart: Math.random() * -5,
    vwEnd: Math.random() * 100,
    vhEnd: Math.random() * 100,
  };


  return (
    <>
      <EffectStyles src={imgEffect} {...effect} />
    </>
  );
}
